<button *ngIf="!editable" type="button" class="btn {{check.btnclass}}" (click)="dynamicEmit();">
  <i class="{{check.icon}} mr-2"></i> {{check.label}}
</button>
